module.exports = __webpack_public_path__ + "static/media/5.e10ee380.svg";